module.exports = __webpack_public_path__ + "static/img/user_img.1adb2406.png";